import { EntityState } from '@ngrx/entity';
import GeoJSON from 'geojson';

import { CropFieldProperties } from '../shared/models';
export enum InteractionType {
  linkSoilAnalysisToCropField = 'linkSoilAnalysisToCropField',
  selectCropField = 'selectCropField',
  selectBlightWarningsLayer = 'selectBlightWarningsLayer',
  selectSoilAnalysis = 'selectSoilAnalysis',
  drawFeature = 'drawFeature',
  modifyFeature = 'modifyFeature',
  cloneRvo = 'cloneRvo',
  drentscheAa = 'drentscheAa',
  cloneFieldFromLastYear = 'cloneFieldFromLastYear',
  drawDivision = 'drawDivision',
  drawOverlap = 'drawOverlap',
  copyShapefileData = 'copyShapefileData',
  importCropFieldsFromCustomer = 'importCropFieldsFromCustomer',
  importRegulatoryManureFields = 'importRegulatoryManureFields',
  synchronizeCropFieldsWithBMS = 'synchronizeCropFieldsWithBMS',
  synchronizeCropFieldsWithRvO = 'synchronizeCropFieldsWithRvO',
}

export enum ExternalSource {
  bms = 'BMS',
  rvo = 'RvO',
}

export interface MapContextState {
  interactionType?: InteractionType;
  previousInteractionType?: InteractionType;
  cropFieldsEnabled?: boolean;
  blightLayerEnabled?: boolean;
  soilAnalysesEnabled?: boolean;
  rvoEnabled?: boolean;
  selectLastYearsFieldEnabled?: boolean;
  groundwaterProtectionZoneEnabled?: boolean;
  drentscheAaEnabled?: boolean;
  shapefileFeatures?: Feature[];
}

export interface Feature extends GeoJSON.Feature<GeoJSON.Polygon> {
  // Of type GeoJson feature
  id: string;
  cropId?: number;
  properties: Partial<CropFieldProperties>;
}

export interface FeatureState extends EntityState<Feature> {
  selectedFeaturesIds?: string[];
  selectedRvoIds?: string[];
  selectedRvoFeatures?: Feature[];
  selectedLastYearsFeatures?: Feature[];
  selectedShapefileFieldFeatures?: Feature[];
  modifyingFeature?: Feature;
  lastYearsFeatures?: Feature[];
}
